export default "<db:commons>\n\t<db:search\n\t\tdata-id='searchform'\n\t\tdata-ignore='1'\n\t\tplaceholder='Deck Name'\n\t/></db:search>\n</db:commons>\n";